import {createSlice} from "@reduxjs/toolkit";

export interface INewsletterSubscriptionModalStore {
    isOpen: boolean;
}

const initialState: INewsletterSubscriptionModalStore = {
    isOpen: false
};

export const newsletterSubscriptionModalSlice = createSlice({
    name: "newsletterSubscriptionModal",
    initialState,
    reducers: {
        openNewsletterSubscriptionModal: (state) => {
            state.isOpen = true;
        },
        closeNewsletterSubscriptionModal: (state) => {
            state.isOpen = false;
        }
    }
});

export const {openNewsletterSubscriptionModal, closeNewsletterSubscriptionModal} = newsletterSubscriptionModalSlice.actions;
import {createSlice} from "@reduxjs/toolkit";

export interface INewsletterSubscriptionModalStore {
    isOpen: boolean;
}

const initialState: INewsletterSubscriptionModalStore = {
    isOpen: false
};

export const newsletterSubscriptionModalSlice = createSlice({
    name: "newsletterSubscriptionModal",
    initialState,
    reducers: {
        openNewsletterSubscriptionModal: (state) => {
            state.isOpen = true;
        },
        closeNewsletterSubscriptionModal: (state) => {
            state.isOpen = false;
        }
    }
});

export const {openNewsletterSubscriptionModal, closeNewsletterSubscriptionModal} = newsletterSubscriptionModalSlice.actions;
